/* eslint-disable eqeqeq */
import { InvResultDataVO } from '__api/dsbc/inv/getInvList';
import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, ScrollView } from 'react-native';

interface Props {
  data?: InvResultDataVO[] | undefined;
  onPress: Function;
}

interface State {
  isShow: boolean;
}

export class InviteRecordPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { data, onPress } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 0.09 }}
                colors={['#C7DEFF', '#FFFFFF']}
                style={styles.main}
              >
                <EmTouchableOpacity
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    padding: 10,
                  }}
                  onPress={() => {
                    onPress && onPress();
                  }}
                >
                  <Image
                    style={styles.closeImg}
                    source={require('../../images/invite/close.png')}
                    resizeMode={'stretch'}
                  />
                </EmTouchableOpacity>
                <Text style={styles.Tittext}>邀请记录</Text>
                <View style={styles.tit}>
                  <Text style={styles.text_l}>活动</Text>
                  <Text style={styles.text_c}>手机号</Text>
                  <Text style={styles.text_r}>邀请状态</Text>
                </View>
                {data && data.length > 0 ? (
                  <ScrollView style={styles.main_c}>
                    {data.map((item, index) => {
                      if (index % 2 == 0) {
                        return (
                          <View style={styles.item} key={index}>
                            <Text style={styles.text3} numberOfLines={1}>
                              {item.projectName}
                            </Text>
                            <Text style={styles.text4} numberOfLines={1}>
                              {item.starPhone}
                            </Text>
                            <Text
                              numberOfLines={1}
                              style={[
                                styles.text5,
                                item.status === '邀请成功'
                                  ? styles.redColor
                                  : item.status === '邀请失败'
                                  ? styles.greenColor
                                  : styles.blueColor,
                              ]}
                            >
                              {item.status}
                            </Text>
                          </View>
                        );
                      } else {
                        return (
                          <View style={styles.item1} key={index}>
                            <Text style={styles.text3} numberOfLines={1}>
                              {item.projectName}
                            </Text>
                            <Text style={styles.text4} numberOfLines={1}>
                              {item.starPhone}
                            </Text>
                            <Text
                              numberOfLines={1}
                              style={[
                                styles.text5,
                                item.status === '邀请成功'
                                  ? styles.redColor
                                  : item.status === '邀请失败'
                                  ? styles.greenColor
                                  : styles.blueColor,
                              ]}
                            >
                              {item.status}
                            </Text>
                          </View>
                        );
                      }
                    })}
                  </ScrollView>
                ) : null}
              </LinearGradient>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    maxHeight: rpx(331),
    backgroundColor: '#fff',
    borderRadius: rpx(12),
    alignItems: 'center',
    paddingBottom: rpx(24),
    // position:'relative'
  },
  main_c: {
    maxHeight: rpx(180),
    width: '100%',
  },
  text: {
    fontSize: rpx(12),
    color: '#6A6DA4',
    lineHeight: rpx(24),
  },
  Tittext: {
    fontSize: rpx(20),
    color: '#3A5DD7',
    fontWeight: 'bold',
    paddingTop: rpx(24),
    paddingHorizontal: rpx(25),
  },
  closeImg: {
    width: rpx(12),
    height: rpx(12),
  },
  text_l: {
    flex: 2,
    textAlign: 'center',
    fontSize: rpx(12),
    color: '#666666',
  },
  text_c: {
    flex: 2,
    textAlign: 'center',
    fontSize: rpx(12),
    color: '#666666',
  },
  text_r: {
    flex: 1.2,
    textAlign: 'left',
    fontSize: rpx(12),
    color: '#666666',
  },
  text3: {
    flex: 2,
    textAlign: 'left',
    fontSize: rpx(12),
    color: '#333333',
  },
  text4: {
    flex: 2,
    textAlign: 'center',
    color: '#333333',
    fontSize: rpx(12),
  },
  text5: {
    flex: 1.2,
    textAlign: 'left',
    color: '#333333',
    fontSize: rpx(12),
  },
  redColor: {
    color: '#FF341E',
  },
  blueColor: {
    color: '#3381E3',
  },
  greenColor: {
    color: '#128E3B',
  },
  tit: {
    width: '100%',
    display: 'flex',
    height: rpx(43),
    alignItems: 'center',
    flexDirection: 'row',
    // justifyContent:'space-between',
    paddingHorizontal: rpx(17.5),
  },
  item: {
    width: '100%',
    display: 'flex',
    height: rpx(32),
    // justifyContent:'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: 'rgba(106,146,255,0.1)',
    borderRadius: rpx(4),
    paddingHorizontal: rpx(17.5),
  },
  item1: {
    width: '100%',
    height: rpx(42),
    // justifyContent:'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    borderRadius: rpx(4),
    paddingHorizontal: rpx(17.5),
  },
});
